import { headerLogoCenter } from './HeaderLogoStore.js';

export const updateHeaderLogoCenter = (value) => headerLogoCenter.update((oldValue) => value);
